import { render } from "./PasswordForm.vue?vue&type=template&id=6a0b0729&scoped=true"
import script from "./PasswordForm.vue?vue&type=script&lang=js"
export * from "./PasswordForm.vue?vue&type=script&lang=js"

import "./PasswordForm.vue?vue&type=style&index=0&id=6a0b0729&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0b0729"]])

export default __exports__